<div class="mydocma-dialog-container mydocma-mm-pool-list-toggle-dialog-container">
  <div class="mydocma-dialog-header">
    <div class="mydomca-dialog-header-title">
      {{title$ | async}}
    </div>
    <div>
      <button mat-icon-button type="button" (click)="onCancel()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="mydocma-dialog-body">
    <mydocma-loader [size]="'small'" class="mydocma-mm-loader" *ngIf="loading | async"></mydocma-loader>

    <div class="pool-list-toggle-content">
      <mydocma-tree
        #tree 
        [options]="poolTreeOptions" 
        [nodeData]="poolScopes$ | async" 
        class="pool-toggle-tree">

        <ng-template mydocmaTreeNodeContent let-tree let-node="node">
          <ng-container class="custom-node-container">
            <div class="node-container-wrapper">
              <ng-container [ngSwitch]="node.data.scope">
                <ng-container *ngSwitchCase="entityScopes.Project">
                  <mydocma-custom-mat-icon class="pool-custom-icon" [iconName]="'_company'"></mydocma-custom-mat-icon>
                </ng-container>
                <ng-container *ngSwitchCase="entityScopes.User">
                  <mydocma-custom-mat-icon class="pool-custom-icon" [iconName]="'_user'"></mydocma-custom-mat-icon>
                </ng-container>
                <ng-container *ngSwitchCase="recentlyUsedScopeId">
                  <mydocma-custom-mat-icon class="pool-custom-icon" [iconName]="'history'"></mydocma-custom-mat-icon>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="!node.data.scope">
                <div style="width: 8px; min-width: 8px; max-width: 8px"></div>
              </ng-container>

              <span class="node-text" *ngIf="node.data.scope; else poolNode">
                {{(node.text | translate)}} ({{node.filteredChildren?.length}})
              </span>

              <ng-template #poolNode>
                <div class="pool-node-content">
                  <div class="mydocma-form">
                    <mat-slide-toggle 
                      labelPosition="after"
                      [checked]="isPoolSelected(node.data)"
                      (change)="onPoolToggle(node.data, $event.checked)"
                      (click)="$event.stopPropagation()"
                      class="pool-name-toggle">
                      <span class="pool-name-text" [title]="node.data.Name" 
                            [class.crossed-out]="!dialogData.isAdd && isPoolSelected(node.data)">
                        <ng-container *ngIf="isPoolInRecentlyUsed(node.data)">
                          <mydocma-custom-mat-icon 
                            class="pool-type-icon" 
                            [iconName]="node.data.IsPublic ? '_company' : '_user'">
                          </mydocma-custom-mat-icon>
                        </ng-container>
                        <span class="pool-name-text-span">
                          {{node.data.Name}}
                        </span>
                      </span>
                    </mat-slide-toggle>
                  </div>
                </div>
              </ng-template>
            </div>
          </ng-container>
        </ng-template>
      </mydocma-tree>
    </div>
  </div>

  <div class="mydocma-dialog-footer">
    <div style="margin-right: 10px">
      <button mat-stroked-button class="mydocma-btn" (click)="onCancel()">
        {{'MM.general.button.cancel' | translate}}
      </button>
    </div>
    <div>
      <button mat-stroked-button class="mydocma-btn-primary" (click)="onDone()" [disabled]="isDoneDisabled">
        {{'MM.general.button.doneButton' | translate}}
      </button>
    </div>
  </div>
</div>